import axios from 'axios';
import toast from 'react-hot-toast';

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const API_URL = process.env.REACT_APP_API_URL || 'https://mcf.hopeinactionforhaiti.org/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});
let refreshPromise = null;

const clearSessionAndRedirect = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('tenant_id');
  localStorage.removeItem('tenant_institution_config');

  if (window.location.pathname !== '/login') {
    window.location.replace('/login?reason=session_expired');
  }
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    const tenant = localStorage.getItem('tenant_id');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (tenant) {
      config.headers['X-Tenant-ID'] = tenant;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isLoginRequest = originalRequest?.url?.includes('/auth/login');
    
    // Handle 401 errors (token expired)
    if (error.response?.status === 401 && !isLoginRequest && !originalRequest?._retry) {
      const refreshToken = localStorage.getItem('refresh_token');

      // There is nothing to renew: the local session and the server session
      // are both considered expired.
      if (!refreshToken) {
        clearSessionAndRedirect();
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      
      try {
        if (!refreshPromise) {
          refreshPromise = axios.post(`${API_URL}/auth/refresh`, {}, {
            headers: { Authorization: `Bearer ${refreshToken}` },
          }).finally(() => { refreshPromise = null; });
        }
        const response = await refreshPromise;
        
        const { access_token } = response.data;
        localStorage.setItem('access_token', access_token);
        
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        clearSessionAndRedirect();
        return Promise.reject(refreshError);
      }
    }

    if (error.response?.data?.code === 'PASSWORD_EXPIRED') {
      if (window.location.pathname !== '/profile') {
        window.location.replace('/profile?password_expired=1');
      }
      return Promise.reject(error);
    }
    
    // Show error toast for other errors
    if (error.response?.status >= 400 && error.response?.status < 500) {
      const message = error.response.data?.message || 'Une erreur est survenue';
      toast.error(message);
    } else if (error.response?.status >= 500) {
      toast.error('Erreur serveur. Veuillez réessayer plus tard.');
    } else if (error.code === 'ECONNABORTED') {
      toast.error('Délai de connexion dépassé');
    } else if (error.code === 'NETWORK_ERROR') {
      toast.error('Erreur de réseau. Vérifiez votre connexion.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
